import { BASE_URL } from 'config'
import { synapse } from 'services/state'

// Function to transform the data filter object in query params
// const createFilterParamsObject = (filter) => {
//   const queryParams = new URLSearchParams()

//   return queryParams
// }

// Fetch that uses the path received and the filter state to perform the new request
export const fetchAsyncFilterSections = async ({
  outputName,
  instanceId,
  changedSection,
  asyncDeps,
  filterData
}) => {
  const payload = {
    filterId: changedSection,
    sections: asyncDeps,
    filters: filterData
  }

  const { body } = await synapse.fetch(
    `${BASE_URL}/output-filters/sections/?outputName=${outputName}&instanceId=${instanceId}`,
    { method: 'POST' },
    payload
  )
  return body
}

export const fetchFilter = async (id, outputName) => {
  const queryParams = new URLSearchParams({
    outputName
  })
  const { body } = await synapse.fetch(
    `${BASE_URL}/output-filters/${id}?${queryParams}`
  )

  return body
}

export const fetchDefaultFilter = async (instanceId, outputName) => {
  const queryParams = new URLSearchParams({
    instanceId,
    outputName
  })

  const { body } = await synapse.fetch(
    `${BASE_URL}/output-filters/default?${queryParams}`
  )

  return body
}

export const fetchFilterList = async (
  outputName,
  instanceId,
  defaultFilter,
  signal
) => {
  const queryParams = new URLSearchParams({
    outputName
  })

  if (defaultFilter) {
    queryParams.append('default', instanceId)
  }

  const { body } = await synapse.fetch(
    `${BASE_URL}/output-filters/?${queryParams}`,
    { signal }
  )

  return body
}

export const insertFilter = async (body, outputName) => {
  const queryParams = new URLSearchParams({
    outputName
  })
  const { body: resBody } = await synapse.fetch(
    `${BASE_URL}/output-filters?${queryParams}`,
    {
      method: 'POST'
    },
    body
  )

  return resBody
}

export const deleteFilter = async (id, outputName) => {
  const queryParams = new URLSearchParams({
    outputName
  })

  const { body } = await synapse.fetch(
    `${BASE_URL}/output-filters/${id}?${queryParams}`,
    {
      method: 'DELETE'
    }
  )

  return body
}

export const updateFilter = async (id, body, outputName) => {
  const queryParams = new URLSearchParams({
    outputName
  })

  const { body: resBody } = await synapse.fetch(
    `${BASE_URL}/output-filters/${id}?${queryParams}`,
    {
      method: 'PUT'
    },
    body
  )

  return resBody
}
